var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCc4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 4H6C4.40869 4 2.88256 4.63206 1.75731 5.75731C0.632063 6.88256 0 8.40869 0 10V37C0 38.5913 0.632063 40.1174 1.75731 41.2427C2.88256 42.3679 4.40869 43 6 43H42C43.5913 43 45.1174 42.3679 46.2427 41.2427C47.3679 40.1174 48 38.5913 48 37V10C48 8.40869 47.3679 6.88256 46.2427 5.75731C45.1174 4.63206 43.5913 4 42 4ZM42 10V16H6V10H42ZM6 37V23H42V37H6Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 27H22V33H10V27Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCc4);
export default __webpack_public_path__ + "static/media/icon_cc4.757a348ae4d33c34103b133df5a3c344.svg";
export { ForwardRef as ReactComponent };